function _getCookie(name) {
  var arg = name + "=";
  var alen = arg.length;
  var clen = document.cookie.length;
  var i = 0;
  while (i < clen) {
      var j = i + alen;
      if (document.cookie.substring(i, j) == arg) {
          return (function(offset){
              var endstr = document.cookie.indexOf (";", offset);
              if (endstr == -1) {
                  endstr = document.cookie.length;
              }
              return decodeURIComponent(document.cookie.substring(offset, endstr));
          })(j);
      }
      i = document.cookie.indexOf(" ", i) + 1;
      if (i == 0) break;
  }
  return "";
}

//设置cookie
function _setCookie(name, value, params) {
  var cStrArr = [];
  cStrArr.push(name + '=' + encodeURIComponent(value));

  if (typeof params === 'undefined') {
    params = {};
  }
  if (typeof params.expires !== 'undefined') {
    var date = new Date();
    date.setTime(date.getTime() + (params.expires) * 1000 * 60);
    cStrArr.push('; expires=' + date.toGMTString());
  }
  cStrArr.push((typeof params.path !== 'undefined') ? '; path=' + params.path : '');
  cStrArr.push((typeof params.domain !== 'undefined') ? '; domain=' + params.domain : '');
  cStrArr.push((typeof params.secure !== 'undefined') ? '; secure' : '');

  document.cookie = cStrArr.join('');
}

//随机获取一个uid
function getRandomUid () {
  var date = new Date().getTime(),
    uid = '',
    fn = '',
    sn = '';

  fn = ((Math.random() * 2147483648) | 0).toString(36);
  sn = Math.round(Math.random() * 10000);
  uid = date + '_' + fn + sn;
  return uid;
}

var sendHTML5VideoInfo = function (params) {

  if (typeof params !== 'undefined') {
    // 合并对象。
    var _merge = function (s, t) {
      var result = {};

      if (!t) {
        return result;
      }

      for (var i in s) {
        result[i] = typeof t[i] !== "undefined" ? t[i] : s[i];
      }

      return result;
    };

    var _host = location.protocol == 'http:' ? 'stadig' : 'stadig0';
    var url = `//${_host}.ifeng.com/media.js`;
    var data = _merge({
          url: '',
          id: '',
          sid: '',
          uid: '',
          from: '',
          provider: '',
          loc: '',
          cat: '',
          se: '',
          ptype: '',
          vid: 'HTML5Player',
          ref: '',//域名
          tm: ''//时间戳
        }, params);

    //针对影视做的特殊统计参数处理
    if (typeof paramInfo !== 'undefined' && typeof paramInfo.type !== 'undefined' && typeof videoinfo !== 'undefined' && typeof videoinfo.cpId !== 'undefined') {
      data.provider = videoinfo.cpId;
    }

    var pArr = [];
    for (var i in data) {
      pArr.push(i + '=' + encodeURIComponent(data[i]));
    }
    var scriptDom = document.createElement('script');
    url = (pArr.length > 0) ? url + '?' + pArr.join('&') : url;
    scriptDom.src = url;
    document.getElementsByTagName("head").item(0).appendChild(scriptDom);
  }
};

function sendXV (playermsg, type) {
  var params = {
    url: type
  };
  params.id = playermsg.videoid;
  params.sid = _getCookie('sid');

  //如果获取userid为空串的话，生成一个userid
  if (_getCookie('userid') === '') {
    _setCookie('userid', getRandomUid(), {domain: '.ifeng.com', path: '/', expires: 60 * 24 * 360});
  }
  params.uid = _getCookie('userid');
  params.loc = _getCookie('ilocid');

  var cid = typeof playermsg.categoryId !== 'undefined' ? playermsg.categoryId : '';
  var cname = playermsg.columnName;
  params.provider = playermsg.provider || '';
  params.cat = cid;
  params.se = typeof cname !== 'undefined' ? cname : '';
  params.ptype = cid === '' ? '' : cid.substr(0, 4);
  params.ref = window.location.href.replace(/#/g,'$');
  params.tm = new Date().getTime();
  params.from = window.location.href.split('//')[1].split('.')[0];
  sendHTML5VideoInfo(params);
}

module.exports = sendXV;


// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.compenont.video.mobile/app/modules/statistics/index.js